import {getByColName, resultSetSize} from "./DashBoardResultSetUtil";
import * as DashboardConstants from "../../constants/DashboardConstants";
import * as places from '../../routing/places'
import * as ViewMode from '../../constants/ViewMode'
import {getInnerStr} from "../../common/StringUtils";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @param widgetDiv
 */
export function drawCalendar(userDashboardChartLine, h, w, widget) {
    let events = [];
    let resources = [];
    createEventsAndResources(userDashboardChartLine, events, resources);
    initCalendar(events, w, h, widget);
    return widget;
}

function createEventsAndResources(data, events, resources) {
    let resourceIds = {};
    for (let i = 0; i < resultSetSize(data.resultSet); i++) {
        let event = createEvent(data, i);
        events.push(event);
        let parameters = data.parameters;
        let resId = getByColName(i, parameters[DashboardConstants.Param_ResourceID], data.resultSet);
        if (resId && !resourceIds[resId])
            resources.push(createResource(data, i));
    }
}

function createResource(data, i) {
    let resource = {};
    let parameters = data.parameters;
    resource.title = getByColName(i, parameters[DashboardConstants.Param_ResourceName], data.resultSet);
    resource.id = getByColName(i, parameters[DashboardConstants.Param_ResourceID], data.resultSet);
    if (!resource.id)
        resource.id = resource.title;
    resource.parentId = getByColName(i, parameters[DashboardConstants.Param_ParentResourceID], data.resultSet);
    return resource;
}


/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} data
 * @param i
 */
function createEvent(data, i) {
    let event = {};
    if (data.parameters[DashboardConstants.Param_LinkToType] && data.parameters[DashboardConstants.Param_LinkToID]) {
        let linkToType = getByColName(i, data.parameters[DashboardConstants.Param_LinkToType], data.resultSet);
        let linkToID = getByColName(i, data.parameters[DashboardConstants.Param_LinkToID], data.resultSet);
        let editPlace = new places.EditPlace();
        editPlace.entityType = linkToType;
        editPlace.id = linkToID;
        editPlace.view = ViewMode.EDIT;
        event.url = "#edit:" + editPlace.tokenize();
    } else
        event.url = getByColName(i, data.parameters[DashboardConstants.Param_URL], data.resultSet);
    event.title = getByColName(i, data.parameters[DashboardConstants.Param_Title], data.resultSet);
    event.eventColor = getByColName(i, data.parameters[DashboardConstants.Param_Color], data.resultSet);
    event.start = getTime(data, i, "From");
    event.end = getTime(data, i, "To");
    if (event.end.getFullYear() < event.start.getFullYear()) {
        event.end = event.start;
        event.isAllDay = true;
    }

    event.resourceId = getByColName(i, data.parameters[DashboardConstants.Param_ResourceID], data.resultSet);
    event.parentResourceId = getByColName(i, data.parameters[DashboardConstants.Param_ParentResourceID], data.resultSet);
    if (!event.resourceId)
        event.resourceId = i + 1;
    event.id = i + 1;
    return event;
}

function getTime(data, i, prefix) {
    let parameters = data.parameters;
    let dateTimeColName = parameters[prefix + "DateTime"];
    if (dateTimeColName)
        return getTimeFrom(dateTimeColName, "yyyy-MM-dd HH:mm:ss.SSS", data, i);
    let dateColName = parameters[prefix + "Date"];
    let timeColName = parameters[prefix + "Time"];
    let date = getTimeFrom(dateColName, "yyyy-MM-dd", data, i);
    let time = getTimeFrom(timeColName, "i", data, i);
    let d = new Date(toTimeMS(date) + toTimeMS(time));
    return d;
}

function toTimeMS(date) {
    if (!date)
        return 0;
    return date.getTime();
}


function getTimeFrom(key, defaultFormat, data, i) {
    let formatStr = defaultFormat;
    if (key.contains("{")) {
        formatStr = getInnerStr(key, "{", "}");
        key = key.replaceAll("{" + key + "}", "");
    }
    let value = getByColName(i, key, data.resultSet);
    if (!value)
        return null;
    if ("i" === formatStr) {
        let d = new Date();
        d.setTime(parseFloat(value));
        return d;
    }
    return new Date(value);
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @param widgetDiv
 */
export function drawScheduler(userDashboardChartLine, h, w, widget) {
    let events = [];
    let resources = [];
    createEventsAndResources(userDashboardChartLine, events, resources);
    let groupByResources = ["ResourceId"];
    let netResources = constructKendoResourcesObject(resources, groupByResources);
    initScheduler(events, netResources, groupByResources, w, h, widget, userDashboardChartLine.parameters[DashboardConstants.Param_OpenLinkInNewTab]);
    return widget;
}

function constructKendoResourcesObject(resources, groupByResources) {
    let resourcesDS = [];
    let parentResourcesDS = [];
    let resourcesMap = new Map();
    let parentResourcesMap = new Map();
    for (let res of resources) {
        resourcesMap.set(res.id, res.title);
        if (res.parentId)
            parentResourcesMap.set(res.parentId, res.parentId);
    }
    for (let [id, title]  of parentResourcesMap.entries()) {
        parentResourcesDS.push({text: title, value: id});
    }
    for (let [id, title]  of resourcesMap.entries()) {
        resourcesDS.push({text: title, value: id});
    }
    let netResources = [];
    let multipleResources = false;
    if (parentResourcesDS.length) {
        netResources.push({field: "parentResourceId", name: "ParentResources", title: "ParentResources", dataSource: parentResourcesDS});
        groupByResources.push("ParentResources");
        multipleResources = true;
    }
    netResources.push({field: "resourceId", name: "ResourceId", title: "Resources", dataSource: resourcesDS, multiple: multipleResources});
    return netResources;
}

export function initScheduler(events, netResources, groupByResources, w, h, widget, openLinkInNewTab) {
    widget.kendoScheduler({
        date: Date.now(),
        startTime: new Date("2017/01/01 00:00 AM"),
        height: h,
        width: w,
        eventHeight: 50,
        majorTick: 60,
        views: ["day",
            {type: "week", selected: true},
            "month",
            "timeline"],
        dataSource: events,
        eventTemplate: `<a id = "calendarContainer" onclick='openResourceUrl(event,this,${openLinkInNewTab});' href=#: url #>#: title #</a>`,
        group: {
            resources: groupByResources
        },
        resources: netResources,
        dataBound: function () {
            let view = this.view();
            let events = this.dataSource.view();
            let eventElement;
            let event;
            for (let idx = 0, length = events.length; idx < length; idx++) {
                event = events[idx];
                eventElement = view.element.find("[data-uid=" + event.uid + "]");
                eventElement.css("background-color", event.eventColor);
            }
        }
    });
}

window.openResourceUrl = function (e, element, openLinkInNewTab) {
    if (openLinkInNewTab) {
        e.preventDefault();
        window.open(element.href, "_blank");
    }
}

function initCalendar(events, w, h, widget) {
    widget.kendoScheduler({
        date: Date.now(),
        startTime: new Date("2017/01/01 00:00 AM"),
        height: h,
        width: w,
        views: [
            "day",
            "workWeek",
            "week",
            {type: "month", selected: true},
            "year",
            "agenda",
            {type: "timeline", eventHeight: 50}
        ],
        dataSource: events,
        eventTemplate: `<a id = "calendarContainer" href=#: url #>#: title #</a>`,
    });
}